import { render, staticRenderFns } from "./XRays.vue?vue&type=template&id=7e8a996e&scoped=true"
import script from "./XRays.vue?vue&type=script&lang=js"
export * from "./XRays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a996e",
  null
  
)

export default component.exports